import React, { useState, useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Card, CardBody, CardTitle, Col, Container, Row } from 'reactstrap';

import {
  LOCATIONS,
  OPTION_AGES,
  OPTION_AGES_EXTRA_BED,
  PAYMENT_TYPE,
  ROOM_TYPE,
} from 'constants/index';

// import { ReactComponent as FlexibleOrangeIconSvg }
// from 'assets/images/location/flexible-orange-icon-svg.svg';
import { ReactComponent as PolicyCheckoutAndDepositIconSvg } from 'assets/images/location/policy-checkout-deposit-icon-svg.svg';
import { ReactComponent as PolicyKidAndExtraBedIconSvg } from 'assets/images/location/policy-kid-extra-bed-icon-svg.svg';
import { ReactComponent as PolicyReceiveRoomIconSvg } from 'assets/images/location/policy-receive-room-icon-svg.svg';
import { ReactComponent as PolicySmokingAndPetIconSvg } from 'assets/images/location/policy-smoking-pet-icon-svg.svg';
import { ReactComponent as PolicyCurfewIconSvg } from 'assets/images/BellSlash.svg';
import { ReactComponent as PolicyOtherIconSvg } from 'assets/images/PencilSimpleLine.svg';

import AppBreadcrumb from 'components/App/Breadcrumb';
import AppButton from 'components/App/Button';
import AppMeta from 'components/App/Meta';

import ModalEditPolicyReceiveRoom from 'components/Modals/ModalEditPolicyReceiveRoom';
import ModalEditPolicyDeposit from 'components/Modals/ModalEditPolicyDeposit';
import ModalEditPolicySmoke from 'components/Modals/ModalEditPolicySmoke';
import ModalEditPolicyCurfew from 'components/Modals/ModalEditPolicyCurfew';
import ModalEditPolicyOther from 'components/Modals/ModalEditPolicyOther';
// import ModalEditPolicyCancelRoomFlex from 'components/Modals/ModalEditPolicyCancelRoomFlex';

import INITIAL_VALUE from 'constants/initialValue';
import { unparseCurrency } from 'utils';

import styles from './Policy.module.scss';

function Policy(props) {
  const {
    placeDetail,
    setting,

    actionGetPlaceDetail,
    actionClearPlaceDetail,
    actionClearListRoomsOfPlace,
    // actionEditCancelPolicy,
    actionEditReceiveRoomPolicy,
    actionEditDepositPolicy,
    actionEditSmokeAndPetPolicy,
    actionEditCurfewPolicy,
    actionEditOtherPolicy,
  } = props;

  // const [isOpenModalCancelRoomFlex, setIsOpenModalCancelRoomFlex] =
  //   useState(false);
  const [isOpenModalReceiveRoom, setIsOpenModalReceiveRoom] = useState(false);
  const [isOpenModalDeposit, setIsOpenModalDeposit] = useState(false);
  const [isOpenModalSmoke, setIsOpenModalSmoke] = useState(false);
  const [isOpenModalCurfew, setIsOpenModalCurfew] = useState(false);
  const [isOpenModalOther, setIsOpenModalOther] = useState(false);

  const location = useLocation();
  const placeId = new URLSearchParams(location.search).get('place');

  const breadcrumbList = [
    {
      name: 'Chỗ nghỉ',
      isActive: false,
      link: `${LOCATIONS.LOCATION_DETAIL.DEFAULT}?place=${placeId}`,
    },
    {
      name: 'Chính sách',
      isActive: true,
      link: '',
    },
  ];

  const {
    // cancelBookingPolicy,
    checkInTime,
    checkOutTime,
    depositPolicy,
    paymentMethods,
    allowSmoking,
    allowPet,
    curfewPolicy,
  } = placeDetail;

  let internationalCard;
  let domesticCard;
  let digitalWallet;
  let cashPayment;

  paymentMethods?.forEach((method) => {
    switch (method.group) {
      case PAYMENT_TYPE.INTERNATIONAL.key:
        internationalCard = method;
        break;
      case PAYMENT_TYPE.DOMESTIC.key:
        domesticCard = method;
        break;
      case PAYMENT_TYPE.QR.key:
        digitalWallet = method;
        break;
      case PAYMENT_TYPE.CASH.key:
        cashPayment = method;
        break;
      default:
        break;
    }
  });

  // const onToggleModalCancelRoomFlex = useCallback(() => {
  //   setIsOpenModalCancelRoomFlex((prev) => !prev);
  // }, []);

  const onToggleModalReceiveRoom = useCallback(() => {
    setIsOpenModalReceiveRoom((prev) => !prev);
  }, []);

  const onToggleModalDeposit = useCallback(() => {
    setIsOpenModalDeposit((prev) => !prev);
  }, []);

  const history = useHistory();
  const onClickEditChildExtraBedPolicy = React.useCallback(() => {
    history.push(
      `${LOCATIONS.LOCATION_DETAIL.CHILD_EXTRA_BED_POLICY}?place=${placeId}`,
    );
  }, []);

  const onToggleModalSmoke = useCallback(() => {
    setIsOpenModalSmoke((prev) => !prev);
  }, []);

  const onToggleModalCurfew = useCallback(() => {
    setIsOpenModalCurfew((prev) => !prev);
  }, []);

  const onToggleModalOther = useCallback(() => {
    setIsOpenModalOther((prev) => !prev);
  }, []);

  const renderChildPolicy = React.useCallback(
    (childrenPolicy) =>
      childrenPolicy.map((item) => {
        switch (true) {
          case item.condition === OPTION_AGES.BELOW.value && +item.price === 0:
            return (
              <Col md="12" className="Section__Card__Policy__Notice" key={item._id}>
                {`Trẻ em dưới ${item.childTo} tuổi được miễn phí phụ thu khi dùng giường có sẵn`}
              </Col>
            );

          case item.condition === OPTION_AGES.BELOW.value && +item.price !== 0:
            return (
              <Col md="12" className="Section__Card__Policy__Notice" key={item._id}>
                {`Trẻ em dưới ${item.childTo} tuổi sẽ phụ thu ${unparseCurrency(item.price)} VNĐ/ trẻ/ phòng/ đêm`}
              </Col>
            );

          case item.condition === OPTION_AGES.FROM.value && +item.price === 0:
            return (
              <Col md="12" className="Section__Card__Policy__Notice" key={item._id}>
                {`Trẻ em từ ${item.childFrom} - ${item.childTo} tuổi được miễn phí phụ thu khi dùng giường có sẵn`}
              </Col>
            );

          case item.condition === OPTION_AGES.FROM.value && +item.price !== 0:
            return (
              <Col md="12" className="Section__Card__Policy__Notice" key={item._id}>
                {`Trẻ em từ ${item.childFrom} - ${item.childTo} tuổi sẽ phụ thu ${unparseCurrency(item.price)} VNĐ/ trẻ/ phòng/ đêm`}
              </Col>
            );
          case item.condition === OPTION_AGES.ABOVE.value:
            return (
              <Col md="12" className="Section__Card__Policy__Notice" key={item._id}>
                {`Trẻ em trên ${item.childFrom} tuổi trở lên phụ thu như người lớn`}
              </Col>
            );

          default:
            return null;
        }
      }),
    [],
  );

  const renderExtraBedPolicy = React.useCallback(
    (extraBedPolicy) =>
      extraBedPolicy.map((item) => {
        switch (true) {
          case item.ageLimitCondition === OPTION_AGES_EXTRA_BED.FROM.value &&
            +item.price === 0:
            return (
              <Col md="12" className="Section__Card__Policy__Notice" key={item._id}>
                {`Khách từ ${item.childFrom} tuổi đến ${item.childTo} được miễn phí phụ
            thu khi dùng giường phụ với ${item.room.name || ROOM_TYPE[item.room.roomName]?.label}`}
              </Col>
            );

          case item.ageLimitCondition === OPTION_AGES_EXTRA_BED.FROM.value &&
            +item.price !== 0:
            return (
              <Col md="12" className="Section__Card__Policy__Notice" key={item._id}>
                {`Khách từ ${item.childFrom} tuổi đến ${item.childTo} phải trả
            thêm ${unparseCurrency(item.price)} VNĐ/khách/ đêm khi dùng giường
            phụ với ${item.room?.name || ROOM_TYPE[item.room?.roomName]?.label}`}
              </Col>

            );

          case item.ageLimitCondition === OPTION_AGES_EXTRA_BED.ANY.value &&
            +item.price === 0:
            return (
              <Col md="12" className="Section__Card__Policy__Notice" key={item._id}>
                {`Khách từ mọi độ tuổi được miễn phí phụ
            thu khi dùng giường
            phụ với ${item.room.name || ROOM_TYPE[item.room.roomName]?.label}`}
              </Col>
            );
          case item.ageLimitCondition === OPTION_AGES_EXTRA_BED.ANY.value &&
            +item.price !== 0:
            return (
              <Col
                key={item._id}
                md="12"
                className="Section__Card__Policy__Notice"
              >
                {`Khách từ mọi độ tuổi phải trả thêm ${unparseCurrency(item.price)} VNĐ/khách/ đêm khi dùng giường
            phụ với ${item.room?.name || ROOM_TYPE[item.room?.roomName]?.label}`}
              </Col>
            );

          default:
            return null;
        }
      }),
    [],
  );

  const toTitleCase = (value) => {
    if (!value || typeof value !== 'string') return '';
    const lower = value.toLowerCase();
    return lower.replace(/(^|[^a-zA-Z]+)([a-zA-Z])/g, (_match, prefix, chr) => (
      `${prefix}${chr.toUpperCase()}`
    ));
  };

  React.useEffect(() => {
    if (placeId) {
      actionGetPlaceDetail({ placeId });
    }

    return () => {
      actionClearPlaceDetail();
      actionClearListRoomsOfPlace();
    };
  }, [placeId]);

  return (
    <div className={`page-content ${styles.Page}`}>
      <AppMeta name="Chính sách chỗ nghỉ" />

      <Container fluid>
        <AppBreadcrumb pageTitle="Chính sách" breadcrumbList={breadcrumbList} />

        <Row>
          <Col md="6" className="mb-4 Col__Container">
            <Card className="Section">
              <div className="Section__Card__Policy__Title__Wrapper">
                <PolicyCheckoutAndDepositIconSvg className="Section__Card__Policy__Title__Image" />

                <CardTitle className="Section__Card__Policy__Title">
                  Chính sách thanh toán và đặt cọc
                </CardTitle>
              </div>

              <CardBody md="6" className="Section__Card__Policy">
                <div className="Section__Card__Policy__Item">
                  <Row className="Section__Card__Policy__Line">
                    <Col md="6" className="Section__Card__Policy__Category">
                      Thẻ quốc tế chấp nhận thanh toán
                    </Col>

                    <Col
                      md="6"
                      className="Section__Card__Policy__Category__Information"
                    >
                      {internationalCard?.children.length > 0
                        ? internationalCard.children.map((c) => toTitleCase(c.name)).join(', ')
                        : 'Không'}
                    </Col>
                  </Row>
                </div>

                <div className="Section__Card__Policy__Item">
                  <Row className="Section__Card__Policy__Line">
                    <Col md="6" className="Section__Card__Policy__Category">
                      Thẻ nội địa chấp nhận thanh toán
                    </Col>

                    <Col
                      md="6"
                      className="Section__Card__Policy__Category__Information"
                    >
                      {domesticCard?.children.length > 0
                        ? domesticCard.children.map((c) => toTitleCase(c.name)).join(', ')
                        : 'Không'}
                    </Col>
                  </Row>
                </div>

                <div className="Section__Card__Policy__Item">
                  <Row className="Section__Card__Policy__Line">
                    <Col md={6} className="Section__Card__Policy__Category">
                      Ví điện tử
                    </Col>

                    <Col
                      md={6}
                      className="Section__Card__Policy__Category__Information"
                    >
                      {digitalWallet?.children.length > 0
                        ? digitalWallet.children.map((c) => toTitleCase(c.name)).join(', ')
                        : 'Không'}
                    </Col>
                  </Row>
                </div>

                <div className="Section__Card__Policy__Item">
                  <Row className="Section__Card__Policy__Line">
                    <Col md={6} className="Section__Card__Policy__Category">
                      Khác
                    </Col>

                    <Col
                      md={6}
                      className="Section__Card__Policy__Category__Information"
                    >
                      {cashPayment?.children.length > 0
                        ? 'Tiền mặt'
                        : 'Không'}
                    </Col>
                  </Row>
                </div>

                <AppButton
                  classes="Section__Card__Policy__Button"
                  onClick={onToggleModalDeposit}
                >
                  Chỉnh sửa
                </AppButton>
              </CardBody>
            </Card>

            {/* <Card className="Section">
              <CardTitle className="Section__Title">
                Chính sách hủy phòng
              </CardTitle>

              <div className="Section__Card"> */}
            {/* <Col>
                  <div className="Section__Card__Information">
                    <div className="Section__Card__Information__Header">
                      <FlexibleOrangeIconSvg className="Section__Card__Information__Header__Icon" />

                      <div className="Section__Card__Information__Header__Title">
                        {cancelBookingPolicy?.freeBeforeDays === 0
                          ? 'Không hoàn hủy'
                          : `Linh động - ${cancelBookingPolicy?.freeBeforeDays} ngày`}
                      </div>
                    </div>

                    <div className="Section__Card__Information__Body">
                      <div className="Section__Card__Information__Body__Wrapper">
                        <div className="Section__Card__Information__Body__Content">
                          <span className="Section__Card__Information__Body__Point">
                            •
                          </span>
                          {cancelBookingPolicy?.freeBeforeDays === 0
                            ? 'Khách không thể hủy đặt phòng miễn phí trước khi tới nhận phòng.'
                            : `Khách có thể hủy miễn phí đến ${cancelBookingPolicy?.freeBeforeDays}
                            ngày trước khi tới nhận phòng.`}
                          <br />
                          <span className="Section__Card__Information__Body__Point">
                            •
                          </span>
                          {cancelBookingPolicy?.cancelPenalty ===
                            'FIRST_NIGHT' &&
                            'Khách sẽ phải trả giá của đêm đầu tiên nếu hủy phòng trước khi
                            tới nhận phòng.'}
                          {cancelBookingPolicy?.cancelPenalty ===
                            '50_PERCENT' &&
                            `Khách sẽ phải trả ${parseFloat(cancelBookingPolicy?.cancelPenalty)}%
                            tổng tiền phòng nếu hủy phòng trước khi tới nhận phòng.`}
                          {cancelBookingPolicy?.cancelPenalty ===
                            '100_PERCENT' &&
                            'Khách sẽ phải trả toàn bộ tiền phòng nếu hủy phòng
                             trước khi tới nhận phòng.'}
                        </div>
                      </div>
                    </div>

                    <div className="Section__Card__Information__Footer">
                      <AppButton
                        classes="Section__Card__Information__Footer__Edit"
                        onClick={onToggleModalCancelRoomFlex}
                      >
                        Chỉnh sửa
                      </AppButton>
                    </div>
                  </div>
                </Col> */}

            {/* <Col md="6">
              <div className="Section__Card__Information">
                <div className="Section__Card__Information__Header">
                  <NoRefundIconSvg className="Section__Card__Information__Header__Icon" />

                  <div className="Section__Card__Information__Header__Title">
                    Không hoàn tiền
                  </div>
                </div>

                <div className="Section__Card__Information__Body">
                  <div className="Section__Card__Information__Body__Wrapper">
                    <div className="Section__Card__Information__Body__Point">•</div>

                    <div className="Section__Card__Information__Body__Content">
                      Khách sẽ phải trả toàn bộ tiền phòng nếu hủy phòng bất kỳ lúc nào.
                    </div>
                  </div>

                  <div className="Section__Card__Information__Body__Wrapper">
                    <div className="Section__Card__Information__Body__Point">•</div>

                    <div className="Section__Card__Information__Body__Content">
                      Khách sẽ phải thanh toán trước toàn bộ tiền phòng bất kỳ lúc nào.
                    </div>
                  </div>
                </div>

                <div className="Section__Card__Information__Footer">
                  <AppButton
                    classes="Section__Card__Information__Footer__Edit btn-danger"
                  >
                    Xóa
                  </AppButton>

                  <AppButton
                    classes="Section__Card__Information__Footer__Apply"
                    outline
                  >
                    Áp dụng cho các chỗ nghỉ còn lại
                  </AppButton>
                </div>
              </div>
            </Col> */}
            {/* </div> */}
            {/* </Card> */}

            <Card className="Section">
              <div className="Section__Card__Policy__Title__Wrapper">
                <PolicySmokingAndPetIconSvg className="Section__Card__Policy__Title__Image" />

                <CardTitle className="Section__Card__Policy__Title">
                  Chính sách hút thuốc và thú cưng
                </CardTitle>
              </div>

              <CardBody md="6" className="Section__Card__Policy">

                <Col md="12" className="Section__Card__Policy__Notice">
                  Khách
                  {!allowSmoking && ' không'}
                  {' '}
                  được hút thuốc trong chỗ nghỉ
                </Col>

                <Col md="12" className="Section__Card__Policy__Notice">
                  Khách
                  {!allowPet && ' không'}
                  {' '}
                  được mang thú cưng
                </Col>

                <AppButton
                  classes="Section__Card__Policy__Button"
                  onClick={onToggleModalSmoke}
                >
                  Chỉnh sửa
                </AppButton>
              </CardBody>
            </Card>

            <Card className="Section">
              <div className="Section__Card__Policy__Title__Wrapper">
                <PolicyCurfewIconSvg className="Section__Card__Policy__Title__Image" />

                <CardTitle className="Section__Card__Policy__Title">
                  Chính sách giờ giới nghiêm
                </CardTitle>
              </div>

              <CardBody md="6" className="Section__Card__Policy">
                <Col md="12" className="Section__Card__Policy__Notice">
                  {curfewPolicy?.from && curfewPolicy?.to
                    ? `Quý khách không được làm ồn sau ${curfewPolicy.from} đến ${curfewPolicy.to}`
                    : 'Chưa thiết lập chính sách giờ giới nghiêm'}
                </Col>

                <AppButton
                  classes="Section__Card__Policy__Button"
                  onClick={onToggleModalCurfew}
                >
                  Chỉnh sửa
                </AppButton>
              </CardBody>
            </Card>

            <Card className="Section">
              <div className="Section__Card__Policy__Title__Wrapper">
                <PolicyOtherIconSvg className="Section__Card__Policy__Title__Image" />

                <CardTitle className="Section__Card__Policy__Title">
                  Chính sách khác
                </CardTitle>
              </div>

              <CardBody md="6" className="Section__Card__Policy">
                <Col md="12" className="Section__Card__Policy__Notice" style={{ whiteSpace: 'pre-line' }}>
                  {placeDetail?.otherPolicy || 'Chưa thiết lập chính sách khác'}
                </Col>

                <AppButton
                  classes="Section__Card__Policy__Button"
                  onClick={onToggleModalOther}
                >
                  Chỉnh sửa
                </AppButton>
              </CardBody>
            </Card>
          </Col>

          <Col md="6" className="mb-4 Col__Container">
            <Card className="Section">
              <div className="Section__Card__Policy__Title__Wrapper">
                <PolicyReceiveRoomIconSvg className="Section__Card__Policy__Title__Image" />

                <CardTitle className="Section__Card__Policy__Title">
                  Chính sách nhận phòng
                </CardTitle>
              </div>

              <CardBody md="6" className="Section__Card__Policy">

                <div className="Section__Card__Policy__Item">
                  <Row className="Section__Card__Policy__Line">
                    <Col md="6" className="Section__Card__Policy__Category">
                      Giờ nhận phòng
                    </Col>

                    <Col
                      md="6"
                      className="Section__Card__Policy__Category__Information"
                    >
                      {checkInTime}
                    </Col>
                  </Row>
                </div>

                <div className="Section__Card__Policy__Item">
                  <Row className="Section__Card__Policy__Line">
                    <Col md="6" className="Section__Card__Policy__Category">
                      Giờ trả phòng
                    </Col>

                    <Col
                      md="6"
                      className="Section__Card__Policy__Category__Information"
                    >
                      {checkOutTime}
                    </Col>
                  </Row>
                </div>

                <Col md="12" className="Section__Card__Policy__Notice">
                  {depositPolicy?.allowDeposit ? (
                    <>
                      Quý khách sẽ được yêu cầu đặt cọc
                      {' '}
                      {depositPolicy?.amount > 0
                        ? unparseCurrency(depositPolicy?.amount)
                        : depositPolicy?.depositPercent}
                      {depositPolicy?.amount > 0 ? ' VNĐ' : '%'}
                      {' '}
                      cho những dịch
                      vụ phát sinh và hoàn trả khi làm thủ tục trả phòng sau khi
                      đã cần trừ hoàn tất
                    </>
                  ) : (
                    'Quý khách sẽ được yêu cầu xuất trình chứng minh thư hoặc hộ chiếu khi làm thủ tục nhận phòng'
                  )}
                </Col>

                <AppButton
                  classes="Section__Card__Policy__Button"
                  onClick={onToggleModalReceiveRoom}
                >
                  Chỉnh sửa
                </AppButton>
              </CardBody>
            </Card>

            <Card className="Section">
              <div className="Section__Card__Policy__Title__Wrapper">
                <PolicyKidAndExtraBedIconSvg className="Section__Card__Policy__Title__Image" />

                <CardTitle className="Section__Card__Policy__Title">
                  Chính sách trẻ em và giường phụ
                </CardTitle>
              </div>

              <CardBody md="6" className="Section__Card__Policy">

                {renderChildPolicy(placeDetail.childrenPolicy || [])}

                {renderExtraBedPolicy(placeDetail.extraBedPolicy || [])}

                <AppButton
                  classes="Section__Card__Policy__Button"
                  onClick={onClickEditChildExtraBedPolicy}
                >
                  Chỉnh sửa
                </AppButton>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* <ModalEditPolicyCancelRoomFlex
        isOpen={isOpenModalCancelRoomFlex}
        onToggleModal={onToggleModalCancelRoomFlex}
        actionEditCancelPolicy={actionEditCancelPolicy}
        actionGetPlaceDetail={actionGetPlaceDetail}
        cancelBookingPolicy={cancelBookingPolicy}
      /> */}

      <ModalEditPolicyReceiveRoom
        isOpen={isOpenModalReceiveRoom}
        onToggleModal={onToggleModalReceiveRoom}
        actionEditReceiveRoomPolicy={actionEditReceiveRoomPolicy}
        actionGetPlaceDetail={actionGetPlaceDetail}
        checkInTime={checkInTime}
        checkOutTime={checkOutTime}
        depositPolicy={depositPolicy}
      />

      <ModalEditPolicyDeposit
        isOpen={isOpenModalDeposit}
        onToggleModal={onToggleModalDeposit}
        actionEditDepositPolicy={actionEditDepositPolicy}
        actionGetPlaceDetail={actionGetPlaceDetail}
        defaultPaymentMethods={setting.paymentMethod}
        paymentMethods={paymentMethods}
      />

      <ModalEditPolicySmoke
        isOpen={isOpenModalSmoke}
        onToggleModal={onToggleModalSmoke}
        actionEditSmokeAndPetPolicy={actionEditSmokeAndPetPolicy}
        actionGetPlaceDetail={actionGetPlaceDetail}
        allowSmoking={allowSmoking}
        allowPet={allowPet}
      />

      <ModalEditPolicyCurfew
        isOpen={isOpenModalCurfew}
        onToggleModal={onToggleModalCurfew}
        actionEditCurfewPolicy={actionEditCurfewPolicy}
        actionGetPlaceDetail={actionGetPlaceDetail}
        hasCurfew={placeDetail.hasCurfew}
        curfewFrom={curfewPolicy?.from}
        curfewTo={curfewPolicy?.to}
      />

      <ModalEditPolicyOther
        isOpen={isOpenModalOther}
        onToggleModal={onToggleModalOther}
        actionEditOtherPolicy={actionEditOtherPolicy}
        actionGetPlaceDetail={actionGetPlaceDetail}
        otherPolicy={placeDetail?.otherPolicy}
      />
    </div>
  );
}

Policy.propTypes = {
  placeDetail: PropTypes.instanceOf(Object),
  setting: PropTypes.instanceOf(Object),

  actionGetPlaceDetail: PropTypes.func.isRequired,
  // actionEditCancelPolicy: PropTypes.func.isRequired,
  actionEditReceiveRoomPolicy: PropTypes.func.isRequired,
  actionClearPlaceDetail: PropTypes.func.isRequired,
  actionClearListRoomsOfPlace: PropTypes.func.isRequired,
  actionEditDepositPolicy: PropTypes.func.isRequired,
  actionEditSmokeAndPetPolicy: PropTypes.func.isRequired,
  actionEditCurfewPolicy: PropTypes.func.isRequired,
  actionEditOtherPolicy: PropTypes.func,
};

Policy.defaultProps = {
  placeDetail: INITIAL_VALUE.OBJECT,
  setting: INITIAL_VALUE.OBJECT,
  actionEditOtherPolicy: () => {},
};

export default Policy;
